import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "facebook",
  "use": "facebook-usage",
  "viewBox": "0 0 500 500",
  "content": "<symbol viewBox=\"0 0 500 500\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"facebook\">\n<path d=\"M353.323 276.214L365.598 195.388H288.813V142.961C288.813 120.843 299.52 99.2718 333.911 99.2718H368.842V30.4612C368.842 30.4612 337.155 25 306.874 25C243.608 25 202.296 63.7197 202.296 133.786V195.388H132V276.214H202.296V471.614C216.409 473.853 230.846 475 245.554 475C260.262 475 274.7 473.853 288.813 471.614V276.214H353.323Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol